var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#637878",
  d: "m19.2 18-4.1-4.1c1.2-1.5 1.9-3.3 1.9-5.4C17 3.8 13.2 0 8.5 0S0 3.8 0 8.5 3.8 17 8.5 17c1.9 0 3.7-.7 5.1-1.7l4.2 4.2zM2 8.5C2 4.9 4.9 2 8.5 2S15 4.9 15 8.5 12.1 15 8.5 15 2 12.1 2 8.5"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h19.2v19.4H0z"
})))));
export default SvgSearchSmall;